/** MUI outlined Select + dropdown menu styling (Store Management filters, regional product status, etc.) */
const COLORS = {
  ink: '#3F3F6E',
  muted: '#6B7280',
  border: '#D7E0F2',
  white: '#FFFFFF',
};

export const storeManagementMenuPaperSx = {
  borderRadius: '5px',
  border: `1px solid ${COLORS.border}`,
  boxShadow: '0 4px 20px rgba(63, 63, 110, 0.12)',
  '& .MuiMenuItem-root': {
    fontFamily: 'Inter Regular, sans-serif',
    fontSize: 14,
    color: COLORS.ink,
  },
  '& .MuiMenuItem-root.Mui-selected': {
    bgcolor: '#fdeee7',
    '&:hover': { bgcolor: '#fcddcf' },
  },
};

export const storeManagementMenuItemSx = {
  fontFamily: 'Inter Regular, sans-serif',
  fontSize: 13,
  fontWeight: 600,
  color: COLORS.ink,
  textTransform: 'capitalize',
  borderRadius: '4px',
  mx: 0.5,
  my: 0.25,
};

/** Menu items with multi-word / acronym labels (e.g. “AI …”) — avoids CSS capitalize mangling. */
export const storeManagementMenuItemPlainSx = {
  ...storeManagementMenuItemSx,
  textTransform: 'none',
};

export const storeManagementOutlinedSelectSx = {
  '& .MuiInputLabel-root': {
    color: COLORS.ink,
    fontSize: '13px',
    fontWeight: 500,
    fontFamily: 'Inter Regular, sans-serif',
  },
  '& .MuiInputLabel-root.Mui-focused': {
    color: COLORS.ink,
  },
  '& .MuiInputLabel-root.MuiInputLabel-shrink': {
    color: COLORS.ink,
    fontWeight: 500,
    paddingLeft: '4px',
  },
  '& .MuiOutlinedInput-root': {
    height: '42px',
    borderRadius: '5px',
    bgcolor: COLORS.white,
    fontFamily: 'Inter Regular, sans-serif',
    fontSize: 13,
    transition: 'all 0.2s ease',
    '& fieldset': { borderColor: COLORS.border, borderWidth: '1px' },
    '&:hover fieldset': { borderColor: COLORS.ink },
    '&.Mui-focused fieldset': { borderColor: COLORS.ink, borderWidth: '1px' },
    '&.Mui-focused .MuiOutlinedInput-notchedOutline': {
      borderColor: `${COLORS.ink} !important`,
    },
    '& .MuiSelect-select': {
      fontSize: '13px',
      color: COLORS.ink,
      textTransform: 'capitalize',
      overflow: 'hidden',
      display: 'flex',
      alignItems: 'center',
    },
    '& .MuiSelect-icon': {
      color: COLORS.ink,
    },
  },
};
